import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { getProjectRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import { IndividualRouteSetting, ProjectViews } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import ProjectDefinition from './views/project-definition/ProjectDefinition';
import ProjectList from './views/project-list/ProjectsList';
import NewProjectDefinition from './views/new-project-definition/NewProjectDefinition';
import FreemiumSpeciesInsights from './views/freemium-species-insights/FreemiumSpeciesInsights';
import SiteFiles from './views/site-files/SiteFiles';
import SiteSummary from './views/site-summary/SiteSummary';

export const projectRouteSettings: { [key in ProjectViews]: IndividualRouteSetting } = {
    projects: {
        name: 'My sites',
        path: '/',
        handler: <ProjectList />,
        resource: Resources.PROJECTS_LIST,
    },
    newProjectDefinition: {
        name: 'New project definition',
        path: '/new-project-definition',
        handler: <NewProjectDefinition />,
        resource: Resources.NEW_PROJECT_DEFINITION,
    },
    editProjectDefinition: {
        name: 'Edit project definition',
        path: '/edit-project-definition',
        handler: <NewProjectDefinition />,
        resource: Resources.NEW_PROJECT_DEFINITION,
    },
    projectDefinition: {
        name: 'Project definition',
        path: '/project-definition',
        handler: <ProjectDefinition />,
        resource: Resources.PROJECT_DEFINITION,
    },
    siteFiles: {
        name: 'Files',
        path: '/site-files',
        handler: <SiteFiles />,
        resource: Resources.SITE_FILES,
    },
    freemiumSpeciesInsights: {
        name: 'Species insights',
        path: '/freemium-species-insights',
        handler: <FreemiumSpeciesInsights />,
        resource: Resources.FREEMIUM_SPECIES_INSIGHTS,
    },
    siteSummary: {
        name: 'Site summary',
        path: '/site-summary',
        handler: <SiteSummary />,
        resource: Resources.SITE_SUMMARY,
    },
};

const Projects = () => {
    const routesConfig = useAppSelector(getProjectRoutesAvailability);

    if (!routesConfig) {
        return null;
    }

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as ProjectViews];
                const routeSetting = projectRouteSettings[routeKey as ProjectViews];

                if (!routeSetting) {
                    return null;
                }

                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <ProtectedRoute isAllowed={isAvailable} redirectPath={'/projects'} routeSetting={routeSetting}>
                                {routeSetting.handler}
                            </ProtectedRoute>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};
export default Projects;
